<!-- secciones delegacion en curso -->
<div class="container u-mt60 u-pb60">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-8">
      <h1 class="u-mb30 txt txt--title">
        Delegación aprobaciones
      </h1>
    </div>
  </div>

  <div class="container container-mb" *ngIf="delegationsInProgressNewData.length > 0">

    <div class="row">
      <div class="col-md-8">
        <div class="txt txt--section u-mb30">
          Delegaciones en curso
        </div>
      </div>
      <div class="col-md-12">
        <div class="table-delegations">
          <div class="tr">
            <div class="th">Nombre</div>
            <div class="th">Correo</div>
            <div class="th">Rut</div>
            <div class="th calendars-th-fixed-width">Fechas delegación</div>
            <div class="th"></div>
            <div class="th"></div>
          </div>
          <!-- <ng-template #listDelegation> -->
          <div class="tr" *ngFor="let item of delegationsInProgressNewData"
            [ngClass]="!updateDelegation ? 'hide' : 'show'">
            <div class="td" data-column="Nombre">{{ item?.name }}</div>
            <div class="td" data-column="Correo">{{ item?.email }}</div>
            <div class="td rutContainer" data-column="Rut">{{ item?.rutDv | parseRut  }}</div>
            <!-- ingresar al mo| date:"dd/MM/YYYY" -->
            <div class="td" data-column="Fechas delegación">{{ item?.dateStart |date:"dd/MM/YYYY" }} -
              {{ !(item?.dateEnd) ? 'Indefinido' : item?.dateEnd |date:"dd/MM/YYYY" }}</div>
            <div class="td"></div>
            <div class="td u-right td--mobilesimple">
              <a class="td__action td__action--edit u-mr20  hoverHand" (click)="onEdit(item?.id)">Editar</a>
              <a class="td__action td__action--delete hover-hand modal_ _trigger hoverHand " data-modal="modal01"
                (click)="showModalConfirmEliminationDelegation(item?.id)">Eliminar</a>
            </div>
          </div>
          <!-- </ng-template> -->
          <div class="tr" *ngIf="updateDelegation" [formGroup]="delegateEditForm">
            <div class="td headersHidden" data-column="Nombre">{{ selectedDelegation.name }}</div>
            <div class="td" data-column="Correo">{{ selectedDelegation.email }}</div>
            <div class="td" data-column="Rut">{{ selectedDelegation.rutDv | parseRut }}</div>

            <div class="td--mobilesimple margin-and-border-bottom" data-column="Fechas delegación">
              <div class="row calendarContainer">
                <div class="col-lg-12 col-md-6 col-12">
                  <div class="form form--required u-mb20">
                    <!-- date start edit delegate -->
                    <label for="" class="label">
                      Delegar desde
                    </label>
                    <div class="calendar-fixed-width-delegation">
                      <app-calendar (valueEmitter)="onEditStartDateChange($event)"
                        [defaultDate]="selectedDelegation.dateStart"></app-calendar>
                      <app-error-message [text]="editStartDateError"></app-error-message>
                    </div>

                  </div>
                  <!-- fin start date Edit  -->
                </div>
                <div class="col-lg-12 col-md-6 col-12">
                  <div class="form form--required">
                    <!-- data end date edit delegate -->
                    <label for="" class="label">
                      Delegar hasta
                    </label>
                    <div class="calendar-fixed-width-delegation">
                      <app-calendar (valueEmitter)="onEditEndDateChange($event)" [canBeUndefined]="true"
                        [defaultDate]="selectedDelegation.dateEnd"></app-calendar>
                      <app-error-message [text]="editEndDateError"></app-error-message>
                    </div>
                    <!-- fin end date edit -->
                  </div>
                </div>
              </div>

            </div>


            <div class="td"></div>
            <div class="td u-vab u-right td--mobilesimple">
              <button type="button" class="btn btn--primary" [ngClass]="{'btn--disabled': !editFormValidations.allFieldsCorrect || !!editEndDateError }" (click)="showModalConfirmEditDelegation()"
                >Guardar cambios</button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Div line -->
    <div class="u-bt u-mt50"></div>
    <div class="u-mt60"></div>

  </div>

  <!-- Delegate by time -->
  <div class="container container-mb" [formGroup]="newDelegationForm">
    <div class="row">

      <div class="col-md-12">
        <p class="u-pb30 txt txt--small">
          A través del siguiente formulario podrás traspasar tus aprobaciones a otra persona. La delegación abarca a
          todas las solicitudes que se ingresan en el periodo indicado.
        </p>
      </div>
      <div class="col-md-12 u-mb60" *ngIf="personData">
        <app-person-card [personData]="personData"></app-person-card>
        <span class="back back--small u-mt10 hoverHand" (click)="onChangeSelected()">
          Buscar otra persona
        </span>
      </div>

      <div class="col-md-12" *ngIf="!personData">
        <div class="box u-mb70">
          <div class="row">
            <div class="col-lg-4">
              <app-select-list title="Persona a delegar" hintText="*El rut debe ser sin puntos y con guión"
                (textInputValueEmitter)="onDelegatePersonTextChange($event)" [optionList]="personOptions"
                placeHolder="Buscar por nombre, rut* o email" (selectedValueEmitter)="setDelegatePersonId($event)"
                [isLoading]="loadingPersonOptions"
              >
              </app-select-list>
            </div>
            <div class="col-lg-3 offset-lg-5">
              <button type="button" class="btn btn--primary btn--big u-mt20" aria-pressed="true"
                (click)="onSelectPerson()" [attr.disabled]="newDelegationFormData.id ? null : true">Buscar
                perfil</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form form--required">
          <label for="" class="label">
            Inicio de la delegación
          </label>
          <app-calendar (valueEmitter)="handleStartDateChange($event)"></app-calendar>
          <div class="form__error u-mt10 error-text-mb"
            *ngIf="newDelegationFormValidations.datesValidation  === DatePickersStatus.START_DATE_LOWER_THAN_TODAY">
            No puedes ingresar una fecha anterior a la fecha actual. Por favor intenta con otra.
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form form--required">
          <label for="" class="label">
            Fin de la delegación
          </label>
          <app-calendar (valueEmitter)="handleEndDateChange($event)" [canBeUndefined]="true"></app-calendar>
          <div class="form__check u-mt10">
            <div class="form__error u-mt10 error-text-mb" *ngIf="
                newDelegationFormValidations.datesValidation === DatePickersStatus.END_DATE_EQUAL_TO_START_DATE ||
                newDelegationFormValidations.datesValidation === DatePickersStatus.START_DATE_HIGGER_THAN_END
              ">
              Debe ingresar una fecha posterior a la fecha de inicio de la delegación. Por favor intenta con otra.
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form">
          <label for="" class="label">
            Comentario
          </label>
          <textarea placeholder="Ingresar comentario" [formControlName]="'noteControl'" maxlength="300"></textarea>
          <small class="character-counter"
            [ngClass]="newDelegationFormData.note.length === 300 ? 'text-red' : ''">{{newDelegationFormData.note.length}}/300
            caracteres</small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="u-bt u-pt50 u-mt50">
          <button type="button" class="btn btn--primary" (click)="showModalConfirmNewDelegation() "
            [attr.disabled]="newDelegationFormValidations.allFieldsCorrect? null : true">Delegar
            mis
            aprobaciones</button>
        </div>
      </div>
    </div>
  </div>
</div>
